import axios from "axios"
import { useContext } from "react"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { AuthContext } from "../../Context/AuthContext"
import "./login.scss"

export default function Login() {

    const navigate = useNavigate()

    const [credentials, setCredentials] = useState({
        username: undefined,
        password: undefined
    })

    const { user, isLoading, isError, dispatch } = useContext(AuthContext);

    const changeHandler = (e) => {
        setCredentials((prev) => ({ ...prev, [e.target.id]: e.target.value }))
    }

    const loginHandler = async (e) => {
        e.preventDefault();
        dispatch({ type: 'LOGIN_START' })
        try {
            const res = await axios.post('/auth/login', credentials)
            if (res.data.data.role !== "user") {
                dispatch({ type: "LOGIN_SUCCESS", payload: res.data.data })
                navigate('/')
            } else {
                dispatch({ type: "LOGIN_FAIL", payload: { message: "You are not allowed" } })
            }
        } catch (error) {
            dispatch({ type: "LOGIN_FAIL", payload: error.response.data })
        }
    }

    // console.log(user)

    return (
        <>
            <div className="login">
                <div className="lContainer">
                    <div className="l-input-group">
                        <input type="text" required name="username" className="l-input" id="username" onChange={changeHandler} />
                        <label className="l-user-label">Username</label>
                    </div>
                    <div className="l-input-group">
                        <input type="password" required name="password" className="l-input" id="password" onChange={changeHandler} />
                        <label className="l-user-label">Password</label>
                    </div>
                    <button className="l-button searchBtn" onClick={loginHandler}>Login</button>
                    {isError && <span className="err">{isError.message}</span>}
                </div>
            </div>
        </>
    )
}
